<div class="u-height-100" fxLayout="column">
  <div fxFlex="100%" class="u-overflow-auto u-showScrollBar u-padding-24">
    <ng-container [ngSwitch]="viewMode">
      <ng-container
        *ngSwitchCase="viewModes.add_roles"
        [ngTemplateOutlet]="deleteForm"
      ></ng-container>
      <ng-container
        *ngSwitchCase="viewModes.summary"
        [ngTemplateOutlet]="summary"
      ></ng-container>
      <ng-container
        *ngSwitchCase="viewModes.success"
        [ngTemplateOutlet]="success"
      ></ng-container>
    </ng-container>
  </div>
  <div
    class="u-padding-8-0 u-padding-0-16 u-borderTop-grey100"
    fxFlex="0 0 auto"
    fxLayoutAlign="start center"
    fxLayoutGap="16px"
  >
    <button
      mat-button
      type="button"
      [disabled]="isLoading"
      (click)="closeDrawer()"
      i18n="@@global.close"
    >
      Close
    </button>
    <button
      *ngIf="viewMode === viewModes.summary"
      mat-button
      type="button"
      color="primary"
      (click)="retry()"
      i18n="@@global.retry"
    >
      Retry
    </button>
    <button
      *ngIf="viewMode === viewModes.add_roles"
      [disabled]="isLoading || !roles.valid"
      mat-raised-button
      type="button"
      color="primary"
      (click)="getRolesRolesToDelete()"
    >
      <ng-container i18n="@@hubConfigRolesBulkDeleteDrawer.deleteRoles"
        >Delete roles</ng-container
      >
      <i
        *ngIf="isLoading"
        nz-icon
        nzType="sync"
        nzSpin
        class="u-marginLeft-8"
      ></i>
    </button>
    <ng-container *ngIf="isLoading">
      <p class="color-grey-300">
        (<ng-container i18n="@@global.progress">Progress</ng-container>:
        {{ progressCompleted }}/{{ totalRoles }})
      </p>
    </ng-container>
  </div>
</div>
<ng-template #deleteForm>
  <p
    class="u-marginBottom-16"
    i18n="@@hubConfigRolesBulkDeleteDrawer.description"
  >
    Enter new options separated by a new line. To bulk delete items, create your
    list in your text editor and paste it in the text below.
  </p>
  <mat-form-field class="mat-form-field-width-100">
    <textarea
      matInput
      cdkTextareaAutosize
      [cdkAutosizeMinRows]="10"
      [cdkAutosizeMaxRows]="15"
      [formControl]="roles"
      placeholder="Example item 1&#10;Example item 2&#10;Example item 3"
      autocomplete="off"
      required="true"
      class="u-showScrollBar"
      i18n-placeholder="@@hubConfigRolesBulkDeleteDrawer.textAreaPlaceholder"
    ></textarea>
  </mat-form-field>
</ng-template>
<ng-template #summary>
  <div class="u-marginBottom-24">
    <p
      *ngIf="0 !== validOptions.length + invalidOptions.length"
      class="u-marginBottom-16"
      i18n="@@hubConfigRolesBulkDeleteDrawer.summary"
    >
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: validOptions }"
      ></ng-container>
      have been deleted successfully and
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: invalidOptions }"
      ></ng-container>
      had errors. Please see the summary below:
    </p>
    <nz-tabset>
      <nz-tab
        *ngIf="validOptions.length"
        nzTitle="Deleted ({{ validOptions.length }})"
        i18n-nzTitle="@@hubConfigRolesBulkDeleteDrawer.addedTab"
      >
        <nz-table
          #validOptionsData
          [nzData]="validOptions"
          nzSize="small"
          nzBordered
          [nzHideOnSinglePage]="true"
        >
          <thead>
            <tr>
              <th i18n="@@hubConfigRolesBulkDeleteDrawer.optionLabel">
                Option
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of validOptionsData.data">
              <td>{{ option.role?.name }}</td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
      <nz-tab
        *ngIf="invalidOptions.length"
        nzTitle="Errors ({{ invalidOptions.length }})"
        i18n-nzTitle="@@hubConfigRolesBulkDeleteDrawer.errorsTab"
      >
        <nz-table
          #invalidOptionsData
          [nzData]="invalidOptions"
          nzSize="small"
          nzBordered
          [nzHideOnSinglePage]="true"
        >
          <thead>
            <tr>
              <th i18n="@@hubConfigRolesBulkDeleteDrawer.optionLabel">
                Option
              </th>
              <th i18n="@@hubConfigRolesBulkDeleteDrawer.errorsLabel">
                What happened?
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let option of invalidOptionsData.data">
              <td>
                {{ option.role?.name }}
              </td>
              <td>
                <span class="color-orange">{{ option.error }}</span>
              </td>
            </tr>
          </tbody>
        </nz-table>
      </nz-tab>
    </nz-tabset>
  </div>
</ng-template>
<ng-template #success>
  <div class="u-marginBottom-16">
    <p i18n="@@hubConfigRolesBulkDeleteDrawer.success">
      <ng-container
        [ngTemplateOutlet]="optionPluralTemplate"
        [ngTemplateOutletContext]="{ $implicit: validOptions }"
      ></ng-container>
      have been deleted
    </p>
  </div>
</ng-template>
<ng-template #optionPluralTemplate let-options>
  <ng-container
    i18n="@@hubConfigRolesBulkDeleteDrawer.optionPlural"
    >{options.length, plural,
      =1 {{{ options.length }} role}
      other {{{ options.length }} roles}

  }</ng-container>
</ng-template>
